module.exports = __webpack_public_path__ + "img/slider-thumb.caee014a.jpg";